'use client';
import React from 'react';
import { useRouter, useParams } from 'next/navigation';
import { SearchIcon as SharedSearchIcon } from '@launchstore/shared-puck';
import type { SearchIconProps } from '@launchstore/shared-puck';

// Storefront wrapper for the shared SearchIcon. The shared
// component is router-agnostic (onSearchSubmit callback); this
// wrapper wires it to next/navigation so search queries push to
// /:country/search?q=<query>.
const SharedSearchIconRender = (SharedSearchIcon as any).render;

const SearchIconImpl: React.FC<SearchIconProps> = (props: any) => {
  const router = useRouter();
  const params = useParams();
  const countryCode = (params?.countryCode as string) || 'us';

  return (
    <SharedSearchIconRender
      {...(props as any)}
      onSearchSubmit={(q: string) => router.push(`/${countryCode}/search?q=${encodeURIComponent(q)}`)}
    />
  );
};

export const SearchIcon: any = { ...SharedSearchIcon, render: (props: any) => <SearchIconImpl {...props} /> };
export default SearchIcon;
